import { render, staticRenderFns } from "./Tiendas.vue?vue&type=template&id=cfcc545a&"
import script from "./Tiendas.vue?vue&type=script&lang=js&"
export * from "./Tiendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports